import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "image-in-chat preview-image-list" }
const _hoisted_2 = { class: "row mx-n2" }
const _hoisted_3 = {
  key: 0,
  class: "warning-duplicate"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "warning-text-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "duplicate-text" }, [
    /*#__PURE__*/_createVNode("p", null, " Duplicate File: File will be automatically deleted if uploaded. "),
    /*#__PURE__*/_createVNode("p", null, "FILE SIZE LARGE."),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("strong", null, "SIZE LIMIT: 25MB ")
    ])
  ])
], -1)
const _hoisted_5 = {
  key: 1,
  class: "warning-duplicate"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "warning-text-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "duplicate-text" }, [
    /*#__PURE__*/_createVNode("p", null, "FILE SIZE LARGE."),
    /*#__PURE__*/_createVNode("p", null, [
      /*#__PURE__*/_createVNode("strong", null, "SIZE LIMIT: 25MB ")
    ])
  ])
], -1)
const _hoisted_7 = {
  key: 2,
  class: "warning-duplicate"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "warning-text-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "duplicate-text" }, [
    /*#__PURE__*/_createVNode("p", null, " Duplicate File: File will be automatically deleted if uploaded. ")
  ])
], -1)
const _hoisted_9 = {
  key: 3,
  class: "shadowed-card bg-white mb-3"
}
const _hoisted_10 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_12 = { class: "imaged-col" }
const _hoisted_13 = { class: "small-img-wrap" }
const _hoisted_14 = { class: "edit-control" }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_16 = { class: "size" }
const _hoisted_17 = { class: "file-actions" }
const _hoisted_18 = { class: "dropdown" }
const _hoisted_19 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_20 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_23 = {
  key: 4,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_24 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_26 = { class: "imaged-col" }
const _hoisted_27 = { class: "small-img-wrap" }
const _hoisted_28 = { class: "edit-control" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_30 = { class: "size" }
const _hoisted_31 = { class: "file-actions" }
const _hoisted_32 = { class: "dropdown" }
const _hoisted_33 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_34 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_37 = {
  key: 5,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_38 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_40 = { class: "imaged-col" }
const _hoisted_41 = { class: "small-img-wrap" }
const _hoisted_42 = { class: "edit-control" }
const _hoisted_43 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_44 = { class: "size" }
const _hoisted_45 = { class: "file-actions" }
const _hoisted_46 = { class: "dropdown" }
const _hoisted_47 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_48 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_51 = {
  key: 6,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_52 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_54 = { class: "imaged-col" }
const _hoisted_55 = { class: "small-img-wrap" }
const _hoisted_56 = { class: "edit-control" }
const _hoisted_57 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_58 = { class: "size" }
const _hoisted_59 = { class: "file-actions" }
const _hoisted_60 = { class: "dropdown" }
const _hoisted_61 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_62 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_63 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_65 = {
  key: 7,
  class: "shadowed-card bg-white mb-2"
}
const _hoisted_66 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_67 = /*#__PURE__*/_createVNode("span", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
], -1)
const _hoisted_68 = { class: "imaged-col" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "small-img-wrap" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-file-word" })
], -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_71 = { class: "size" }
const _hoisted_72 = { class: "file-actions" }
const _hoisted_73 = { class: "dropdown" }
const _hoisted_74 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_75 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt mr-2" }, null, -1)
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_78 = {
  key: 8,
  class: "media-wrap shadowed-card bg-white mb-2"
}
const _hoisted_79 = {
  key: 0,
  class: "loader-wrapper"
}
const _hoisted_80 = /*#__PURE__*/_createVNode("div", { class: "centered-wrap" }, [
  /*#__PURE__*/_createVNode("span", {
    class: "spinner-border big-spinner",
    role: "status"
  }, [
    /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...")
  ])
], -1)
const _hoisted_81 = /*#__PURE__*/_createVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_82 = { class: "size" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imagesToUpload, (image, imageIndex) => {
        return (_openBlock(), _createBlock("div", {
          class: "col-md-6 px-2",
          key: imageIndex
        }, [
          (!image.isvalidToUpload && image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_3, [
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          (!image.isvalidToUpload && !image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _hoisted_6
              ]))
            : _createCommentVNode("", true),
          (image.isvalidToUpload && image.duplicateFile)
            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          (
            image.extension === 'jpg' ||
            image.extension === 'png' ||
            image.extension === 'jpeg' ||
            image.extension === 'gif'
          )
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                (image.isuploded && image.isvalidToUpload)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _hoisted_11
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _createVNode("img", {
                      src: image.file,
                      alt: "",
                      height: "200"
                    }, null, 8, ["src"])
                  ]),
                  _createVNode("h5", null, [
                    (!image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          href: "javascript:void(0)",
                          title: "click to rename",
                          onClick: ($event: any) => (_ctx.renameUploadImage(image))
                        }, _toDisplayString(image.name), 9, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_14, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.name = $event),
                          id: "user-name",
                          type: "text",
                          class: "form-control bg-light",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.name]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_15
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", _hoisted_16, _toDisplayString(image.size), 1)
                ]),
                _createVNode("div", _hoisted_17, [
                  _createVNode("div", _hoisted_18, [
                    _hoisted_19,
                    _createVNode("div", _hoisted_20, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_21,
                        _hoisted_22
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'pdf')
            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_24, [
                      _hoisted_25
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _createVNode("img", {
                      src: 
                  _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/pdf.png`
                    : 'img/pdf.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: "click to rename",
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, [
                        _createVNode("h5", null, _toDisplayString(image.name), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_28, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.name = $event),
                          id: "user-name",
                          type: "text",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          class: "field-value form-control",
                          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.name]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_29
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", _hoisted_30, _toDisplayString(image.size), 1)
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_35,
                        _hoisted_36
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'xls' || image.extension === 'xlsx' || image.extension === 'xlsm' 
          ||image.extension === 'xlsb'||image.extension === 'xltx')
            ? (_openBlock(), _createBlock("div", _hoisted_37, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_38, [
                      _hoisted_39
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode("img", {
                      src: 
                  _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/excel.png`
                    : 'img/excel.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: "click to rename",
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, [
                        _createVNode("h5", null, _toDisplayString(image.name), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_42, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.name = $event),
                          id: "user-name",
                          type: "text",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          class: "field-value form-control",
                          onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.name]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_43
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", _hoisted_44, _toDisplayString(image.size), 1)
                ]),
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createVNode("div", _hoisted_48, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_49,
                        _hoisted_50
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'ppt' || image.extension === 'pptm' || image.extension === 'pptx')
            ? (_openBlock(), _createBlock("div", _hoisted_51, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_52, [
                      _hoisted_53
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, [
                    _createVNode("img", {
                      src: 
                  _ctx.state.data.imageBaseUrl
                    ? `${_ctx.state.data.imageBaseUrl}img/ppt.png`
                    : 'img/ppt.png'
                ,
                      alt: ""
                    }, null, 8, ["src"])
                  ]),
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: "click to rename",
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, [
                        _createVNode("h5", null, _toDisplayString(image.name), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_56, [
                    (image.isEdit)
                      ? _withDirectives((_openBlock(), _createBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": ($event: any) => (image.name = $event),
                          id: "user-name",
                          type: "text",
                          onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                          class: "field-value form-control",
                          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                        }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                          [_vModelText, image.name]
                        ])
                      : _createCommentVNode("", true),
                    (image.isEdit)
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          class: "save-icon",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                        }, [
                          _hoisted_57
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("p", _hoisted_58, _toDisplayString(image.size), 1)
                ]),
                _createVNode("div", _hoisted_59, [
                  _createVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createVNode("div", _hoisted_62, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_63,
                        _hoisted_64
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (image.extension === 'doc' || image.extension === 'docx')
            ? (_openBlock(), _createBlock("div", _hoisted_65, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_66, [
                      _hoisted_67
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_68, [
                  _hoisted_69,
                  (!image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        title: "click to rename",
                        onClick: ($event: any) => (_ctx.renameUploadImage(image))
                      }, [
                        _createVNode("h5", null, _toDisplayString(image.name), 1)
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (image.isEdit)
                    ? _withDirectives((_openBlock(), _createBlock("input", {
                        key: 1,
                        "onUpdate:modelValue": ($event: any) => (image.name = $event),
                        id: "user-name",
                        type: "text",
                        onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                        class: "field-value form-control",
                        onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                      }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                        [_vModelText, image.name]
                      ])
                    : _createCommentVNode("", true),
                  (image.isEdit)
                    ? (_openBlock(), _createBlock("a", {
                        key: 2,
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                      }, [
                        _hoisted_70
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode("p", _hoisted_71, _toDisplayString(image.size), 1)
                ]),
                _createVNode("div", _hoisted_72, [
                  _createVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createVNode("div", _hoisted_75, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: ($event: any) => (_ctx.removeSelectedImage(image))
                      }, [
                        _hoisted_76,
                        _hoisted_77
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (
            image.extension === 'mp4' ||
            image.extension === 'mov' ||
            image.extension === 'MOV' ||
            image.extension === 'wmv' ||
            image.extension === 'webm' ||
            image.extension === 'ogg' ||
            image.extension === 'avi' ||
            image.extension === 'x-ms-wmv'
          )
            ? (_openBlock(), _createBlock("div", _hoisted_78, [
                (image.isuploded)
                  ? (_openBlock(), _createBlock("div", _hoisted_79, [
                      _hoisted_80
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("img", {
                  src: 
              _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/video-icon.png`
                : 'img/video-icon.png'
            ,
                  alt: "",
                  height: "200"
                }, null, 8, ["src"]),
                (!image.isEdit)
                  ? (_openBlock(), _createBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      title: "click to rename",
                      onClick: ($event: any) => (_ctx.renameUploadImage(image))
                    }, [
                      _createVNode("h5", null, _toDisplayString(image.name), 1)
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (image.isEdit)
                  ? _withDirectives((_openBlock(), _createBlock("input", {
                      key: 2,
                      "onUpdate:modelValue": ($event: any) => (image.name = $event),
                      id: "user-name",
                      type: "text",
                      onKeydown: _withKeys(($event: any) => (_ctx.renameUploadImageSave(image)), ["enter"]),
                      class: "field-value form-control",
                      onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.blurField && _ctx.blurField(...args)))
                    }, null, 40, ["onUpdate:modelValue", "onKeydown"])), [
                      [_vModelText, image.name]
                    ])
                  : _createCommentVNode("", true),
                (image.isEdit)
                  ? (_openBlock(), _createBlock("a", {
                      key: 3,
                      href: "javascript:void(0)",
                      onClick: ($event: any) => (_ctx.renameUploadImageSave(image))
                    }, [
                      _hoisted_81
                    ], 8, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode("p", _hoisted_82, _toDisplayString(image.size), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}